import { OctopusError } from "client/resources";

export interface ErrorDetails {
    [key: string]: string;
}

export interface Errors {
    message: string;
    errors: string[];
    statusCode?: number;
    parsedHelpLinks?: string[];
    helpText?: string;
    helpLink?: string;
    fullException?: string;
    fieldErrors: {
        [other: string]: string;
    };
    details?: ErrorDetails;
}

export interface FieldErrors {
    [key: string]: string;
}

export interface ErrorActions {
    getFieldError: (fieldName: string) => string;
    setError: (message: string, errors: string[], fieldErrors: FieldErrors) => void;
    setOctopusError: (error: OctopusError, map?: (error: Errors) => Errors) => void;
}

export function createErrorsFromOctopusError(err: OctopusError): Errors {
    return {
        message: err.ErrorMessage,
        errors: err.Errors || [],
        parsedHelpLinks: err.ParsedHelpLinks,
        helpLink: err.HelpLink,
        helpText: err.HelpText,
        fullException: err.FullException,
        fieldErrors: {},
        statusCode: err.StatusCode,
        details: err.Details,
    };
}
